import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const FeesAndVacancies = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Fees and Vacancies
      </Typography>

      <Typography gutterBottom>
        Please get in touch if you would like information regarding any
        vacancies.
        <br />
        Children may arrive at 08:00 or later, and should be picked up by 17:00.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Fees
      </Typography>

      <Typography>
        Private full or part time - £6.00 per hour.
        <br />
        I take Early Years government funding and operate the stretched offer, covering 45 weeks of the year. 
        <br />
        <br />
        Sundries and consumables are not charged.
        <br />
        Sickness or holidays of a child will be charged at full price.
        <br />
        I will not charge for my own sickness or holidays.
        <br />
        <br />
        Nappies aren't provided, so please bring your own.
        <br />
        Wipes used during changes will be provided.
      </Typography>
    </Box>
  );
};

export default FeesAndVacancies;
